import { Outlet } from 'react-router-dom';

import * as S from './Layout.styled';

export const Layout = () => (
  <S.Container>
    <Outlet />
  </S.Container>
);
